import { OrderJobsSearchRequest } from '@trukt/tms-api/OrderService';
import { createKey } from '../../createKey';

const keyHandler = createKey('order-jobs');

export const OrderJobsServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<OrderJobsSearchRequest>(),
};
